module.exports = __webpack_public_path__ + "static/media/add-on.4489bea6.png";